import Utils from '../utils/basic.utils'

let defaultGlobalConfig = {
    domainUrl:"/zwsk-boot",
    staticDomainUrl:"/zwsk-boot/static",
    webSocketUrl: '',
    http : {
      timeout: 60000, // 接口超时时间:
    },
    profiles: "dev",
    iconUrl: '//at.alicdn.com/t/c/font_4758873_j8gvzkwusmc.js' // 图标链接
};

let zkGlobalConfig = window._CONFIG;

// 全局配置如果存在, 则合并默认(不存在使用默认)
if (zkGlobalConfig) Utils.mergeObject(zkGlobalConfig, defaultGlobalConfig);
else zkGlobalConfig = defaultGlobalConfig // 不存在使用默认

if(process.env.VUE_APP_BASE_URL){
  zkGlobalConfig["domainUrl"] = process.env.VUE_APP_BASE_URL
  zkGlobalConfig["staticDomainUrl"] = process.env.VUE_APP_BASE_URL + "/static"
}

if(process.env.VUE_APP_STATIC_URL ){
  zkGlobalConfig["staticDomainUrl"] = process.env.VUE_APP_STATIC_URL
}

if(process.env.NODE_ENV){
  zkGlobalConfig["profiles"] = process.env.NODE_ENV;
}
if(process.env.VUE_APP_RUN_MODE) {
  zkGlobalConfig["runMode"] = process.env.VUE_APP_RUN_MODE
}

if(process.env.VUE_APP_SOCKET_URL) {
  zkGlobalConfig["webSocketUrl"] = process.env.VUE_APP_SOCKET_URL
}


window._CONFIG = zkGlobalConfig
export default zkGlobalConfig
